import { ISolarPanel } from "@/services/UsageEstimationService/types"

const solarPanelTypes: ISolarPanel[] = [
  {
    annualOutput: 217.8,
    name: "360 Watt Panel",
  },
  {
    annualOutput: 145.2,
    name: "240 Watt Panel",
  },
]
export default solarPanelTypes
